import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from 'react-router-dom';
import BombermanGameLoop from './BombermanGameLoop';
import HomePage from './HomePage';
import NicknameInput from './NicknameInput';

const GameWithParams = ({ nickname }) => {
  const { roomId } = useParams();
  return <BombermanGameLoop roomId={roomId} nickname={nickname} />;
};


const GameRouter = () => {
  const [nickname, setNickname] = useState(null);
  const [nicknameLoaded, setNicknameLoaded] = useState(false);

  useEffect(() => {
    const storedNickname = localStorage.getItem('bomberman-nickname');
    setNickname(storedNickname);
    setNicknameLoaded(true);
  }, []);

  const handleNicknameSet = (newNickname) => {
    setNickname(newNickname);
  };

  if (!nicknameLoaded) {
    return null; // Loading state
  }

  if (!nickname) {
    return <NicknameInput onNicknameSet={handleNicknameSet} />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage nickname={nickname} onNicknameChange={handleNicknameSet} />} />
        <Route path="/multiplayer" element={<BombermanGameLoop roomId={null} nickname={nickname} />} />
        <Route path="/game/:roomId" element={<GameWithParams nickname={nickname} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default GameRouter;